export interface ChemicalDetails {
  id: string;
  chemicalName: string;
  productName: string;
  casNo: string;
  ecNo: string;
  pictogram: string;
  signalWord: string;
  hazardCodes: string;
  hazardStatements: string;
  hazardIdentification: string;
  physicalHazards: string;
  precautionaryStatements: string;
  generalInformation: string;
  healthRiskRating?: number;
  safetyRiskRating?: number;
  environmentalRiskRating?: number;
  unNumber?: string;
  transportName?: string;
  transportHazardClass?: string;
  packingGroup?: string;
}

export const chemicalItems: ChemicalDetails[] = [
  {
    id: "un1789",
    chemicalName: "Hydrochloric Acid (UN1789)",
    productName: "Hydrochloric acid, ≥32%",
    casNo: "7647-01-0",
    ecNo: "231-595-7",
    pictogram: "Corrosive",
    signalWord: "Danger",
    hazardCodes: "R34, R37",
    hazardStatements: "Causes burns; Irritating to respiratory system",
    hazardIdentification: "Classified as Hazardous Substance and Dangerous Goods. Causes burns.",
    physicalHazards: "Corrosive liquid; releases hydrogen chloride gas under fire conditions",
    precautionaryStatements: "S26, S45; avoid contact/inhalation; use PPE",
    generalInformation: "HCl, MW 36.46 g/mol, light yellow liquid, pungent odor",
    healthRiskRating: 3,
    safetyRiskRating: 3,
    environmentalRiskRating: 2,
  },
  // {
  //   id: "un1824",
  //   chemicalName: "Sodium Hydroxide Solution, 6 M",
  //   productName: "Sodium Hydroxide Standard Solution, 6 M (Brand: Fluka)",
  //   casNo: "1310-73-2",
  //   ecNo: "215-185-5",
  //   pictogram: "Corrosive (GHS05) / EC Symbol: C (Corrosive)",
  //   signalWord: "Danger",
  //   hazardCodes: "R35 (Equivalent GHS classification: Causes severe burns)",
  //   hazardStatements: "Causes severe burns. Material is extremely destructive to mucous membranes, eyes, skin, and upper respiratory tract.",
  //   hazardIdentification: "Hazardous Substance; Dangerous Goods; Corrosive substance. Causes severe burns to skin and eyes. Harmful if inhaled, swallowed, or absorbed through skin.",
  //   physicalHazards: "Strong alkaline corrosive liquid; reacts with acids, water, organic materials, chlorinated solvents, aluminum, phosphorus, tin, and zinc. Stable under recommended storage conditions.",
  //   precautionaryStatements: "S26: In case of contact with eyes, rinse immediately with plenty of water and seek medical advice. S37/39: Wear suitable gloves and eye/face protection. S45: In case of accident or if you feel unwell, seek medical advice immediately.",
  //   generalInformation: "Colourless liquid, pH 14.0, molecular weight 40.00 g/mol, completely miscible in water, strongly alkaline solution.",
  //   healthRiskRating: 4,
  //   safetyRiskRating: 4,
  //   environmentalRiskRating: 3,
  // },
  {
    id: "copper-sulfate",
    chemicalName: "Copper Sulfate",
    productName: "Copper(II) sulfate pentahydrate cryst. EMPROVE® ESSENTIAL Ph Eur, BP, USP; Copper(II) sulphate pentahydrate",
    casNo: "7758-99-8",
    ecNo: "231-847-6",
    pictogram: "GHS05 (Corrosion), GHS09 (Environmental Hazard)",
    signalWord: "Danger",
    hazardCodes: "H302, H318, H400, H410",
    hazardStatements: "H302: Harmful if swallowed. H318: Causes serious eye damage. H400: Very toxic to aquatic life. H410: Very toxic to aquatic life with long lasting effects.",
    hazardIdentification: "Acute Toxicity Category 4 (Oral); Serious Eye Damage Category 1; Acute Aquatic Toxicity Category 1; Chronic Aquatic Toxicity Category 1.",
    physicalHazards: "Not combustible; not flammable; not classified as explosive; no oxidizing properties. Strong heating may cause decomposition.",
    precautionaryStatements: "P273: Avoid release to the environment. P280: Wear eye protection. P305 + P351 + P338: IF IN EYES: Rinse cautiously with water for several minutes. Remove contact lenses, if present and easy to do. Continue rinsing. P313: Get medical advice/attention.",
    generalInformation: "Blue, odourless solid. Used for pharmaceutical production and as a cosmetic raw material. Formula: CuSO₄·5H₂O.",
    healthRiskRating: 2,
    safetyRiskRating: 2,
    environmentalRiskRating: 3,
  },
  {
    id: "un2796",
    chemicalName: "Sulfuric Acid (UN2796)",
    productName: "Sulfuric Acid 50%, Sulphuric Acid, Battery Acid (dilute grades)",
    casNo: "7664-93-9",
    ecNo: "231-639-5",
    pictogram: "GHS05 (Corrosion)",
    signalWord: "Danger",
    hazardCodes: "H290, H314",
    hazardStatements: "H290: May be corrosive to metals. H314: Causes severe skin burns and eye damage.",
    hazardIdentification: "Corrosive to Metals Category 1; Skin Corrosion Category 1A; causes severe burns and serious eye damage.",
    physicalHazards: "May be corrosive to metals; non-combustible; reacts violently with water and many organic materials; reacts with metals releasing hydrogen gas; strong heating may cause decomposition.",
    precautionaryStatements: "P234: Keep only in original container. P260: Do not breathe mist/vapours. P264: Wash thoroughly after handling. P280: Wear protective gloves/protective clothing/eye protection/face protection. P301+P330+P331: IF SWALLOWED: Rinse mouth. Do NOT induce vomiting. P303+P361+P353: IF ON SKIN: Remove contaminated clothing and rinse skin with water. P304+P340: IF INHALED: Remove person to fresh air. P305+P351+P338: IF IN EYES: Rinse cautiously with water for several minutes. P310: Immediately call a POISON CENTER/doctor. P390: Absorb spillage to prevent material damage. P405: Store locked up. P406: Store in a corrosion-resistant container.",
    generalInformation: "H₂SO₄, Molecular Weight: 98.08 g/mol, colorless to slightly yellow liquid, concentration 49-51% (UN2796 grade), highly corrosive mineral acid.",
    healthRiskRating: 4,
    safetyRiskRating: 4,
    environmentalRiskRating: 2,
  },
  {
    id: "sodium-hydroxide-solution",
    chemicalName: "Sodium Hydroxide Solution 48%",
    productName: "Sodium Hydroxide Solution 48%, Caustic Soda Solution 48%, Lye Solution 48%, Sodium Hydroxide Aqueous Solution",
    casNo: "1310-73-2",
    ecNo: "215-185-5",
    pictogram: "GHS05 (Corrosion)",
    signalWord: "Danger",
    hazardCodes: "H290, H314",
    hazardStatements: "H290: May be corrosive to metals. H314: Causes severe skin burns and eye damage.",
    hazardIdentification: "Corrosive to Metals Category 1; Skin Corrosion Category 1A; causes severe burns to skin and eyes; corrosive substance.",
    physicalHazards: "May be corrosive to metals; reacts violently with acids; reacts with aluminum, zinc, and other metals producing hydrogen gas; non-combustible but may generate heat on dilution.",
    precautionaryStatements: "P260: Do not breathe mist/vapours. P264: Wash thoroughly after handling. P280: Wear protective gloves/protective clothing/eye protection/face protection. P301+P330+P331: IF SWALLOWED: Rinse mouth. Do NOT induce vomiting. P303+P361+P353: IF ON SKIN: Remove contaminated clothing and rinse skin with water. P305+P351+P338: IF IN EYES: Rinse cautiously with water for several minutes and remove contact lenses if present. P310: Immediately call a POISON CENTER or doctor. P363: Wash contaminated clothing before reuse. P405: Store locked up. P406: Store in a corrosion-resistant container.",
    generalInformation: "NaOH, molecular weight 40.00 g/mol, clear to slightly hazy colorless liquid, strongly alkaline, concentration approximately 48% w/w.",
    healthRiskRating: 3,
    safetyRiskRating: 3,
    environmentalRiskRating: 2,
  },
  {
    id: "un2031",
    chemicalName: "Nitric Acid (UN2031)",
    productName: "Nitric Acid 65-70%; Aqua Fortis; Hydrogen Nitrate",
    casNo: "7697-37-2",
    ecNo: "231-714-2",
    pictogram: "GHS03 (Oxidizer), GHS05 (Corrosion)",
    signalWord: "Danger",
    hazardCodes: "H272, H314, H318",
    hazardStatements: "H272: May intensify fire; oxidiser. H314: Causes severe skin burns and eye damage. H318: Causes serious eye damage.",
    hazardIdentification: "Oxidizing Liquid Category 2; Skin Corrosion Category 1A; Serious Eye Damage Category 1; strong corrosive oxidizing acid.",
    physicalHazards: "Strong oxidizing agent; may intensify fire; reacts with combustible and reducing materials; reacts with metals producing hydrogen gas; non-flammable but supports combustion.",
    precautionaryStatements: "P221: Take any precaution to avoid mixing with combustibles. P210: Keep away from heat. No smoking. P303+P361+P353: IF ON SKIN (or hair): Remove contaminated clothing and rinse skin with water. P305+P351+P338: IF IN EYES: Rinse cautiously with water for several minutes. P405: Store locked up. P501: Dispose of contents/container according to regulations.",
    generalInformation: "HNO₃, Molecular Weight: 63.01 g/mol, colorless liquid with pungent odor, strong oxidizing mineral acid, concentration typically 65-70% for UN2031 grade.",
    healthRiskRating: 4,
    safetyRiskRating: 4,
    environmentalRiskRating: 3,
    unNumber: "UN2031",
    transportName: "NITRIC ACID",
    transportHazardClass: "Class 8 (Corrosive)",
    packingGroup: "II",
  },
  {
    id: "sodium-thiosulfate",
    chemicalName: "Sodium Thiosulfate",
    productName: "Sodium Thiosulfate; Sodium Thiosulphate",
    casNo: "7772-98-7",
    ecNo: "231-867-5",
    pictogram: "None Required (Not classified as hazardous under GHS)",
    signalWord: "None Required",
    hazardCodes: "None Assigned",
    hazardStatements: "Not a hazardous substance or mixture according to GHS classification.",
    hazardIdentification: "Not classified as a hazardous substance or mixture. No GHS label elements required.",
    physicalHazards: "Not combustible. Chemically stable under normal conditions. Risk of reaction with strong oxidizing agents, nitrates, nitrites, peroxides, fluorine, and acids. Ambient fire may release sulfur oxides and sodium oxides.",
    precautionaryStatements: "Avoid inhalation of dust. Wear suitable eye protection and gloves when handling. Do not allow product to enter drains. Store tightly closed in a dry place away from acids.",
    generalInformation: "Formula: Na₂S₂O₃; Molecular Weight: 158.11 g/mol; White powder; pH 6.0-8.5 (50 g/L at 20°C); Water solubility 210 g/L at 20°C.",
    healthRiskRating: 1,
    safetyRiskRating: 1,
    environmentalRiskRating: 1,
  },
  {
    id: "un1230",
    chemicalName: "Methanol (UN1230)",
    productName: "Methanol, Methyl Alcohol, Wood Alcohol, Carbinol, Wood Spirit",
    casNo: "67-56-1",
    ecNo: "200-659-6",
    pictogram: "GHS02 (Flame), GHS06 (Skull and Crossbones), GHS08 (Health Hazard)",
    signalWord: "Danger",
    hazardCodes: "H225, H301, H311, H331, H320, H360D, H370, H373",
    hazardStatements: "H225: Highly flammable liquid and vapour. H301: Toxic if swallowed. H311: Toxic in contact with skin. H331: Toxic if inhaled. H320: Causes eye irritation. H360D: May damage the unborn child. H370: Causes damage to organs. H373: May cause damage to organs through prolonged or repeated exposure.",
    hazardIdentification: "Flammable Liquid Category 2; Acute Toxicity (Oral, Dermal, Inhalation) Category 3; Reproductive Toxicity Category 1B; STOT Single Exposure Category 1; STOT Repeated Exposure Category 2.",
    physicalHazards: "Highly flammable liquid and vapour; severe fire hazard; may form explosive vapour-air mixtures; reacts violently with oxidising agents.",
    precautionaryStatements: "P201, P210, P260, P264, P270, P271, P280, P301+P310, P304+P340, P305+P351+P338, P403+P235, P405, P501.",
    generalInformation: "CH₃OH, Molecular Weight: 32.04 g/mol, clear colourless highly flammable liquid with sweet alcoholic odour, miscible with water.",
    healthRiskRating: 3,
    safetyRiskRating: 4,
    environmentalRiskRating: 2,
  },
  {
    id: "sodium-bisulfate",
    chemicalName: "Sodium Bisulfate",
    productName: "Sodium Hydrogen Sulphate Anhydrous; Sodium Bisulfate",
    casNo: "7681-38-1",
    ecNo: "231-665-7",
    pictogram: "GHS05 (Corrosion)",
    signalWord: "Danger",
    hazardCodes: "H318",
    hazardStatements: "H318: Causes serious eye damage.",
    hazardIdentification: "Serious Eye Damage Category 1. No environmental or physical hazards identified.",
    physicalHazards: "Stable under normal conditions. Not combustible. Thermal decomposition may release irritating gases and vapours.",
    precautionaryStatements: "P280: Wear protective gloves/protective clothing/eye protection/face protection. P305+P351+P338: IF IN EYES: Rinse cautiously with water for several minutes. P310: Immediately call a poison centre or doctor. P403: Store in a well-ventilated place. P501: Dispose of contents/container properly.",
    generalInformation: "NaHSO₄, white solid, molecular formula NaHSO₄, strongly acidic inorganic salt.",
    healthRiskRating: 2,
    safetyRiskRating: 2,
    environmentalRiskRating: 1,
  },
];
